import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import addon_sensors, {
	addon_plus_devices_g3,
} from '@devices/settings/device_settings/addon_sensors.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import safety_gen_2_auto_recovery from '@devices/settings/device_settings/safety_gen_2_auto_recovery.js';
import app_setting_pm_gen_2 from '@devices/settings/device_settings/app_setting_pm_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import settings_gen_2 from '@devices/settings/device_settings/settings_gen_2.js';
import bluetooth_bt_home_control_gen_2 from '@devices/settings/device_settings/bluetooth_bt_home_control_gen_2';

export default {
	name: 'Shelly1PMG4',
	friendly_name: '1 PM Gen 4',
	family: 'relay',
	isPM: true,
	addons: addon_plus_devices_g3,
	reset_from_input: true,
	modes: {
		relay: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'overvoltage',
				'forgotten_lights',
				'overtemperature',
			],
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				addon_sensors,
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_bt_home_control_gen_2,
				safety_gen_2_auto_recovery,
				app_setting_pm_gen_2,
				share,
				settings_gen_2,
			],
		},
	},
};
